(() => {
  if (window.cgmMorganaCta) return;
  window.cgmMorganaCta = true;

  // CGM 22-10-2026: dopo "Aggiungi al carrello" porta subito al carrello, dove c'è il pannello
  // unico "Completa l'acquisto" (privato/ditta, IVA 22/10, dati fattura).
  const onCartPage = location.pathname.replace(/\/$/, '').endsWith('/cart');
  if (!onCartPage) {
    document.addEventListener('shopify:cart:lines-update', (event) => {
      if (window.__cgmGoingToCart) return;
      const go = () => { window.__cgmGoingToCart = true; location.href = '/cart'; };
      Promise.resolve(event.promise).then((res) => {
        if (res && res.status && Number(res.status) >= 400) return;
        go();
      }).catch(() => {});
    });
  }

  if (location.pathname.includes('preventivo-fotovoltaico-morgana')) return;
  function strip() {
    if (document.querySelector('.cgm-morgana-strip')) return;
    const hg = document.getElementById('header-group');
    if (!hg) return;
    const a = document.createElement('a');
    a.className = 'cgm-morgana-strip';
    a.href = '/pages/preventivo-fotovoltaico-morgana';
    a.setAttribute('aria-label', 'Preventivo fotovoltaico con Morgana');
    a.innerHTML = '<span aria-hidden="true">☀</span><span>Preventivo con Morgana</span><span class="cgm-morgana-strip__go">Clicca qui ›</span>';
    hg.insertAdjacentElement('afterend', a);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', strip, { once: true });
  else strip();
})();
